import React from 'react';
import { Skeleton } from 'antd';

export const Input = ({
  loading,
  size,
  children,
  width,
}: {
  loading?: boolean;
  size?: 'large' | 'small' | 'default';
  width?: number;
  children: React.ReactNode;
}) => (
  <>
    {loading ? (
      <Skeleton.Input
        className="Placeholder Input"
        size={size}
        active={true}
        style={{ width }}
      />
    ) : (
      children
    )}
  </>
);
